import { h, render, Component } from 'preact'
import Results from './Results'
import Category from './Category'
import Label from './Label'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class Blog extends Component {
  state = {
    items: [],
    isLoading: null,
    fullyLoaded: false,
    pages: null,
    count: 6,
    activeCat: '',
    activeLabel: '',
    categories: [],
    labels: []
  }

  componentDidMount() {
    this.fetchCategory()
    this.fetchLabels()
    this.fetchPosts()
  }

  fetchCategory() {
    const array = []
    window
      .fetch('/wp-json/wp/v2/categories', {
        credentials: 'same-origin'
      })
      .then(response => {
        response
          .json()
          .then(r => {
            const categories = r
            ;[...categories].forEach((category, index) => {
              if (category.count > 0) {
                const object = {
                  name: category.name,
                  id: category.id
                }
                array.push(object)
              }
            })
          })
          .then(() => {
            this.setState({ categories: array })
          })
      })
  }

  fetchLabels() {
    const array = []
    window
      .fetch('/wp-json/wp/v2/post-labels', {
        credentials: 'same-origin'
      })
      .then(response => {
        response
          .json()
          .then(r => {
            const labels = r
            ;[...labels].forEach((label, index) => {
              if (label.count > 0) {
                const object = {
                  name: label.name,
                  id: label.id
                }
                array.push(object)
              }
            })
          })
          .then(() => {
            this.setState({ labels: array })
          })
      })
  }

  fetchPosts() {
    let offset = this.state.items.length
    let count = this.state.count
    console.log('fetch')
    this.setState(state => ({
      isLoading: true
    }))
    const labelId = this.state.activeLabel.id ? `&post-labels[]=${this.state.activeLabel.id}` : ''
    window
      .fetch(`/wp-json/wp/v2/posts?per_page=${count}&offset=${offset}&filter[cat]=${this.state.activeCat}${labelId}`, {
        credentials: 'same-origin'
      })
      .then(response => {
        response
          .json()
          .then(r => {
            const items = [...this.state.items]
            const array = items.concat(r)
            this.setState(state => ({
              items: array,
              pages: response.headers.get('x-wp-total')
            }))
          })
          .then(() => {
            if (this.state.pages !== this.state.items.length.toString()) {
              this.setState(state => ({
                fullyLoaded: false
              }))
            } else {
              this.setState(state => ({
                fullyLoaded: true
              }))
            }
            this.setState(state => ({
              isLoading: false
            }))
          })
      })
  }

  handleChange = () => {
    if (this.state.pages === (this.state.items.length + 1).toString()) {
      this.setState(state => ({
        fullyLoaded: true
      }))
    }
    this.fetchPosts()
  }

  handleCatClick = e => {
    this.setState({ activeCat: e.currentTarget.dataset.id, items: [] })
    this.fetchPosts()
  }

  handleLabelClick = e => {
    this.setState({ activeLabel: { name: e.currentTarget.dataset.name, id: e.currentTarget.dataset.id }, items: [] })
    this.fetchPosts()
  }

  render() {
    return (
      <div className="c-blog-overview__wrapper u-flex u-flex-sb">
        <div className="c-blog-overview__filters u-flex u-flex-v-center">
          {this.state.categories.length > 0 ? (
            <Category
              type="Categorie"
              items={this.state.categories}
              handleClick={this.handleCatClick.bind(this)}
              activeCat={this.state.activeCat}
            />
          ) : null}
          {this.state.labels.length > 0 ? (
            <Label
              type="Labels"
              items={this.state.labels}
              handleClick={this.handleLabelClick.bind(this)}
              activeLabel={this.state.activeLabel}
            />
          ) : null}
        </div>
        {this.state.items.length > 0 ? (
          <Results results={this.state.items} />
        ) : !this.state.isLoading ? (
          <div className="c-error">Helaas zijn er geen berichten met de huidige filter beschikbaar</div>
        ) : null}
        {this.state.isLoading ? (
          <div className="c-loading-overlay">
            <div class="c-loading-overlay__item c-loading-overlay__item--0" />
            <div class="c-loading-overlay__item c-loading-overlay__item--1" />
            <div class="c-loading-overlay__item c-loading-overlay__item--2" />
            <div class="c-loading-overlay__item c-loading-overlay__item--3" />
            <div class="c-loading-overlay__item c-loading-overlay__item--4" />
            <div class="c-loading-overlay__item c-loading-overlay__item--5" />
          </div>
        ) : null}
        {!this.state.fullyLoaded ? (
          <div className="c-blog-overview__link-container u-text-center">
            <div onClick={this.handleChange.bind(this)} class="c-blog-overview__link">
              Meer berichten
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

const container = document.querySelector('.js-blog-overview')

if (container !== null) {
  render(<Blog />, container)
}



// WEBPACK FOOTER //
// ./src/js/blog/index.js